// extracted by mini-css-extract-plugin
export default {"FloatingButtonContainer":"FloatingButton-module__FloatingButtonContainer--gD0z9"};